export default __webpack_public_path__ + "static/media/support-classicon.c69e52e0.webp";